import React from 'react'
import PropTypes from 'prop-types'
import { Input, getColor, mergeProps } from 'labguard-cdk'
import styles from './ThresholdInput.scss'

const ThresholdInput = ({ color, ...props }) => (
  <Input
    {...mergeProps()(
      {
        className: styles.input,
        // prevent invisible white on white color
        style: { color: getColor(color === 'white' ? 'dark' : color) },
      },
      props
    )}
    type="number"
    alignRight={false}
  />
)

ThresholdInput.defaultProps = {
  color: 'dark',
}

ThresholdInput.propTypes = {
  ...Input.propTypes,
  color: PropTypes.string,
}

export default ThresholdInput
